import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import GrowthShell from '../../components/growth/GrowthShell';
import { findGrowthSection } from '../../lib/growthSections';

// One placeholder per Growth OS section until each is built. An unknown
// section — and /dashboard, whose home is /admin2/growth itself — go to the
// dashboard rather than rendering an empty shell.
export default function GrowthSection({ user, profile, lang }) {
  const { section } = useParams();
  const s = findGrowthSection(section);
  if (!s || s.slug === 'dashboard') return <Navigate to="/admin2/growth" replace />;

  return (
    <GrowthShell user={user} profile={profile} lang={lang} active={s.slug} title={s.ar}>
      <div className="gos-soon">
        <span className="gos-badge-soon">قيد الإنشاء</span>
        <h2>{s.ar}</h2>
        <p>هذا القسم من MAABAR Growth OS قيد الإنشاء.</p>
      </div>
    </GrowthShell>
  );
}
